import directiveAccordionCtrl from '../controllers/accordion';
import directiveAdvancedSearchCtrl from '../controllers/directiveAdvancedSearch';
import directiveApplyFastResultCtrl from '../controllers/directiveApplyFastResult';
import directiveDatePickerWrapperCtrl from '../controllers/directiveDatePickerWrapper';
import directiveFastResultCtrl from '../controllers/directiveFastResult';
import directiveFastResultTriggerCtrl from '../controllers/directiveFastResultTrigger';
import directiveMeetingStaffCtrl from '../controllers/directiveMeetingStaff';
import DirectiveRaceCourseCtrl from '../controllers/directiveRaceCourse';
import directiveSelectDateCtrl from '../controllers/directiveSelectDate';
import directiveSuccessBoxesCtrl from '../controllers/directiveSuccessBoxes';
import directiveTickerCtrl from '../controllers/directiveTicker';
import directiveMoveTopOnFocus from '../controllers/directiveMoveTopOnFocus';
import directiveTableToolbarCtrl from './directiveTableToolbarCtrl';
import horseTableCtrl from '../controllers/horseTable';
import myRatingCtrl from '../controllers/myRating';
import LinkTriggerCtrl from '../controllers/linkTrigger';
import MainCtrl from '../controllers/main';
import raceReplayCtrl from '../controllers/raceReplayCtrl';
import videoControlsCtrl from '../controllers/videoControlsCtrl';
import navBarCtrl from './navBarCtrl';
import { createBarriers } from 'rp-auth';

createBarriers();

const controllers = angular.module('results.controllers', [])
    .controller('MainCtrl', MainCtrl)
    .controller('directiveAccordionCtrl', directiveAccordionCtrl)
    .controller('directiveAdvancedSearchCtrl', directiveAdvancedSearchCtrl)
    .controller('directiveApplyFastResultCtrl', directiveApplyFastResultCtrl)
    .controller('directiveDatePickerWrapperCtrl', directiveDatePickerWrapperCtrl)
    .controller('directiveFastResultCtrl', directiveFastResultCtrl)
    .controller('directiveFastResultTriggerCtrl', directiveFastResultTriggerCtrl)
    .controller('directiveMeetingStaffCtrl', directiveMeetingStaffCtrl)
    .controller('DirectiveRaceCourseCtrl', DirectiveRaceCourseCtrl)
    .controller('directiveSelectDateCtrl', directiveSelectDateCtrl)
    .controller('directiveSuccessBoxesCtrl', directiveSuccessBoxesCtrl)
    .controller('directiveTickerCtrl', directiveTickerCtrl)
    .controller('directiveMoveTopOnFocusCtrl', directiveMoveTopOnFocus)
    .controller('directiveTableToolbarCtrl', directiveTableToolbarCtrl)
    .controller('horseTableCtrl', horseTableCtrl)
    .controller('LinkTriggerCtrl', LinkTriggerCtrl)
    .controller('myRatingCtrl', myRatingCtrl)
    .controller('raceReplayCtrl', raceReplayCtrl)
    .controller('videoControlsCtrl', videoControlsCtrl)
    .controller('navBarCtrl', navBarCtrl);

export default controllers;



// WEBPACK FOOTER //
// ./src/js/controllers/index.js